import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from '@reduxjs/toolkit';
import { rejectValue } from 'redux/helpers';

// import { GET_INTEGRATIONS } from 'services/api';
import { INTEGRATION, INTEGRATION_ALL, INTEGRATION_SEARCH } from './types';

const FAKE_DATA = [
  {
    id: 'IN_123456789abc1',
    name: 'XYZ Test Integration',
    type: 'XYZ Media',
    created_by: 'XYZ Test',
    date: '2021-08-04T09:54:15.000000Z',
  },
  {
    id: 'IN_123456789abc2',
    name: 'XYZ Test Integration',
    type: 'XYZ Media',
    created_by: 'XYZ Test',
    date: '2021-08-04T09:54:15.000000Z',
  },
  {
    id: 'IN_123456789abc3',
    name: 'XYZ Test Integration',
    type: 'XYZ Media',
    created_by: 'XYZ Test',
    date: '2021-08-04T09:54:15.000000Z',
  },
  {
    id: 'IN_123456789abc4',
    name: 'XYZ Test Integration',
    type: 'XYZ Media',
    created_by: 'XYZ Test',
    date: '2021-08-04T09:54:15.000000Z',
  },
];

const integrationAdapter = createEntityAdapter();

export const initialState = integrationAdapter.getInitialState({
  isLoading: false,
  detailsIsLoading: false,
  pagination: {
    total: 4,
    total_pages: 1,
    current_page: 1,
    per_page: 25,
    count: 4,
  },
  params: {
    per_page: 25,
  },
  search: {
    term: '',
  },
});

export const getIntegrations = createAsyncThunk(
  INTEGRATION_ALL,
  async (_, { rejectWithValue, getState }) => {
    try {
      // const companyId = getState().company.current;
      // const { per_page } = getState().integration.params;

      // const { data, meta } = await GET_INTEGRATIONS({
      //   per_page,
      //   company_id: companyId,
      // });

      // if (!data.length) return { data: [], pagination: meta.pagination };
      // const _data = data.map(flatIntegration);

      return { data: FAKE_DATA, pagination: initialState.pagination };
    } catch (error) {
      return rejectWithValue(
        rejectValue({ ...error.response, skipNotification: true })
      );
    }
  }
);

export const searchIntegrations = createAsyncThunk(
  INTEGRATION_SEARCH,
  async (_, { rejectWithValue, getState }) => {
    try {
      // const companyId = getState().company.current;
      const { term } = getState().integration.search;

      if (!term) {
        return;
      }

      // const { data, meta } = await GET_INTEGRATIONS({
      //   term,
      //   company_id: companyId,
      // });

      // if (!data.length) return { data: [], pagination: meta.pagination };

      // const _data = data.map(flatIntegration);

      return { data: FAKE_DATA, pagination: initialState.pagination };
    } catch (error) {
      return rejectWithValue(rejectValue(error.response));
    }
  }
);

const integrationSlice = createSlice({
  name: INTEGRATION,
  initialState,
  reducers: {
    setParams: (state, { payload }) => {
      state.params = { ...state.params, ...payload };
    },
    setSearchTerm: (state, { payload }) => {
      state.search.term = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIntegrations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getIntegrations.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getIntegrations.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        integrationAdapter.setAll(state, payload.data);
        state.pagination = payload.pagination;
      })
      .addCase(searchIntegrations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(searchIntegrations.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(searchIntegrations.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        integrationAdapter.setAll(state, payload.data);
        state.pagination = payload.pagination;
      })
      .addDefaultCase((state) => state);
  },
});

export const integrationSelectors = integrationAdapter.getSelectors(
  (state) => state.integration
);

export const integrationAllSelector = (state) => ({
  data: integrationSelectors.selectAll(state),
  pagination: state.integration.pagination,
  isLoading: state.integration.isLoading,
  params: state.integration.params,
  searchTerm: state.integration.search.term,
});

export const { setParams, setSearchTerm } = integrationSlice.actions;

export default integrationSlice.reducer;
